import { DeployerGridController } from '../controller/DeployerGridController';
import { BaseWebComponentElement } from '../../../../framework/BaseWebComponentElement';
import { toggleVisibility } from '../../../../utils/htmlElement.utils';

export class DeployerGridWebComponent extends BaseWebComponentElement {
  public static companyId: string | undefined;
  public controller!: DeployerGridController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: DeployerGridController,
    });
  }

  public async reload(): Promise<void> {
    await this.controller?.reloadGrid();
  }

  public setWarningVisibility(isVisible: boolean): void {
    toggleVisibility(this.controller.view.dom.$warningMessage, isVisible);
  }
}
